module.exports = require("@swa-ui/core/defines");